import { Injectable } from "@angular/core";
import {CheckoutDeliveryModeClearedEvent, CheckoutDeliveryModeEventListener, CheckoutQueryResetEvent } from "@spartacus/checkout/base/root";

@Injectable({
  providedIn: 'root',
})
export class EbCheckoutDeliveryModeEventListener extends CheckoutDeliveryModeEventListener {
  protected override onDeliveryModeCleared(): void {
    this.subscriptions.add(
      this.eventService
        .get(CheckoutDeliveryModeClearedEvent)
        .subscribe(({ userId, cartId, cartCode }) => {
          this.eventService.dispatch({}, CheckoutQueryResetEvent);
        })
    );
  }
}
